"use client";

import { JSX, useContext, useEffect, useState } from "react";
import {
  BTM_CENTER,
  MID_CENTER
} from "rivals/components/shared/Ads/Benji/constants";
import LDRB from "rivals/components/shared/Ads/LDRB";
import LREC from "rivals/components/shared/Ads/LREC";
import {
  AdContext,
  AdDispatchContext
} from "rivals/components/shared/Ads/adContext";
import AdWrapper from "rivals/components/shared/Ads/container";
import type { Props } from "./types";

/**
 * Component wrapper that is responsible for rendering the next appropriate ad slot
 * during infinite scroll
 */
export default function InfiniteAd({
  size,
  slotType
}: Props): JSX.Element | null {
  // Get the initial values from the AdContext
  const state = useContext(AdContext);

  // Set the initial value to local state, never increment this value
  const [adSlotIndexState] = useState(state[`${slotType}Slot`]);
  const [locationCount] = useState(state[`${slotType}Location`]);

  const dispatch = useContext(AdDispatchContext);

  useEffect(() => {
    // Increment the ad slot index upon initial render
    dispatch({ payload: slotType, type: "INCREMENT_AD_SLOT" });
  }, [dispatch, slotType]);

  return (
    <AdWrapper
      ad={slotType === "ldrb" ? LDRB : LREC}
      location={slotType === "ldrb" ? BTM_CENTER : MID_CENTER}
      locationCount={locationCount}
      size={size}
      slotNumber={adSlotIndexState}
    />
  );
}
